module.exports = __webpack_public_path__ + "static/img/step1.c3372a9e.png";